import { TransportPlaceTaskType, TransportTemplateInDb } from 'generated/backend-api';

export const transportTemplates: TransportTemplateInDb[] = [
    {
        transport: {
            name: 'BA - BRNO 2',
            fixedName: true,
            desiredVehicleProfile: 11002,
            places: [
                {
                    name: 'Bratislava, Slovensko',
                    addressStructured: [
                        {
                            lang: 'cs',
                            address: '(SK) 811 06, Bratislava, Podchod Hodžovo námestie',
                            countryCode: 'SK',
                            country: 'Slovensko',
                            town: 'Bratislava',
                            route: 'Podchod Hodžovo námestie',
                            streetAddress: 'Podchod Hodžovo námestie 2978',
                            postalCode: '811 06'
                        },
                        {
                            lang: 'en',
                            address: '(SK) 811 06, Bratislava, Podchod Hodžovo námestie',
                            countryCode: 'SK',
                            country: 'Slovakia',
                            town: 'Bratislava',
                            route: 'Podchod Hodžovo námestie',
                            streetAddress: 'Podchod Hodžovo námestie 2978',
                            postalCode: '811 06'
                        },
                        {
                            lang: 'sk',
                            address: '(SK) 811 06, Bratislava, Podchod Hodžovo námestie',
                            countryCode: 'SK',
                            country: 'Slovensko',
                            town: 'Bratislava',
                            route: 'Podchod Hodžovo námestie',
                            streetAddress: 'Podchod Hodžovo námestie 2978',
                            postalCode: '811 06'
                        }
                    ],
                    center: {
                        type: 'Point',
                        coordinates: [17.1077477, 48.1485965]
                    },
                    polygon: {
                        type: 'Polygon',
                        coordinates: [
                            [
                                [17.1077477, 48.15039313056823],
                                [17.110079722571353, 48.149494815284115],
                                [17.110079722571353, 48.14769818471588],
                                [17.1077477, 48.14679986943176],
                                [17.10541567742865, 48.14769818471588],
                                [17.10541567742865, 48.149494815284115],
                                [17.1077477, 48.15039313056823]
                            ]
                        ]
                    },
                    crossingPoints: [
                        {
                            lon: 17.14803083491765,
                            lat: 48.832516125712914,
                            visitedAt: undefined
                        }
                    ],
                    distance: 0,
                    duration: 0,
                    durationBuffer: 600,
                    route: 'k`{dHkjlgB?xB{@J_AFyAJq@DiBJaFXeDR_BPk@JqATKByB`@[Bg@Fe@Fm@JYDo@PMDoBbAgGdBYHwBd@{Bd@{Ah@{B|Aa@\\y@dAk@~@}@jB{BbGcArEs@tDc@xCu@pEEXGXCH[nAOz@{@hFSdDInI@dBAr@ChCYxDcAjJi@fEgB|JeAxE_AtDo@zB]jACHe@|AQj@kDrKiCrFc@l@ILaApA[d@e@t@U`@cB`DwA`DkAfCIPgCxFmBhEg@dAiKrUi@lAOXeA`CkDrH_BhDq@jAu@hAi@p@OP]\\UXg@`@w@p@GFoBhA}@ZwBr@uAxAe@lAu@|Ew@tCcAfFa@|A_AbE_AhEcA`EeCfIgC~GM^Ud@]hAmA~ByA`CyBbDwBjCiClCQPcF`E_EhCmB~@eErAgLdCkKnBG@wKlByTrEyCx@k@N_Bb@iBf@qRfG_Cz@MDqCdAuFzBQFoAj@_DtAQHSHyL~F_KnFoP`KuLjIaf@~^wMfJiSjMwPnJyVbMaKrEiLvEaP~FiNrEgBh@qC|@sQrEwQdE}Cn@uI|AwMtBqFr@eSxBuBPeGd@iEZ}YxAkJP}MJmNAgZq@sOw@}TiBsLsAsRkC}I_B{NsCcN}CoWgH{N_FqOyFaGcC_S_IqLiE{KkDuPiEcRkDmDi@iDc@wBWcMkA{E]sIa@cHQqFI_M@iWx@yQvAaKpAoe@`HmL|AkPhBeKz@uNz@iMd@aJPcLFuD@uQQuOe@gNu@_NgAyRyBwFw@yGeAsOsCoSwEaL{CkOwEiR{GsN_GuAq@qP{Hcm@_\\cTaKoH{CcMuEqFgB_Q}EuSuEoF_AyGeA{KuAgGq@_Ly@wEYuQi@wCC_IE{NLsMd@uKn@}It@yLvA}HjAwGhAgNrCaLrCuF~Aw`@tLyKfDoCv@wR|E_QlDyLrBqPrBkIx@oM~@iMn@qJV}HJeR?oy@_BaK@mL\\qJp@oFl@_Fr@mF~@aJnBmLhD{LpEcH~C_I|D}sAtq@qQtIsJ~DsI|C{NnEcMzCmOtCmHdAeD^kFj@{CTiF`@iI\\kBFiEHcQBwPc@eKo@cFc@mGs@kJsAic@eH_OqB_]eDwKu@wTcAmPc@gJK_RC}QTiJT}Sx@qPfAcQ~AqI`A{RhCqH~@sATuK|ByIfBeCf@}EfAsUbGcSdGuAb@gXpJ{JzDqNhG_GpCaAd@eAf@uFnCk@J_ChAi@VyATi@?iAY}OiJsBwByBgCsBwCqDsF{AgBeCoB}B_CKK}F{GkD{C[UgCaBkDaBgCw@gFq@i@GQCwC[_C_@UEg@Wc@]kAeBGK[o@EMKUUe@GOSa@ISwA_D{A_Da@y@gBgDYg@}CqFi@{@aA{@c@OAe@CGWCMP@`@Sd@c@t@u@f@]LcDp@_BFe@Ee@Ia@M]IwDgAICGCqFwAeBi@SGu@S_@Me@OICeGmBaAc@cCcAqKmEiBw@sKoEsKoEeBs@_JwDyKmFgEsBoQyIQIkP_IwOqHqd@oTcAe@oAm@uXuM_JmEyJcGKIwD}B{HuEuAe@}Ba@sCCgBRgBd@iJbEcRlIuD`Ak@FkE@wQQaUSsBIu@QcBs@{AuASW}CmE}@sA{ByCKOgEcFiBiByDaDyAcAECOKeJcFq@e@_CmBe_@g_@kXaYyKiLyB_CqDqEwAsBQWkVw^uNcTcHqK}DmFOSWYkG{GwJaIgRaOcQuMuCyBoSaPsI}GkBkBgC_E_EmHqA_CkQ{[aFcJyIaPsXkg@aByCKQuByDwByDm@iAQ[}EyIqO}XwHmNsAeCuCmFEIuGoLQ]{EaPwBmH}DeN}@{Cu@iCIWuLgb@Qo@]oAsPgl@wCgKw@oCm@yBiAwDeBuGOq@Iq@YwCIkB?{EPwCt@uGT_B`B}NBcAKoE_@}Bo@uBeA_Cw@aBMSi@u@COk@k@_@Y_Aa@}@M_@Ci@@EFM@cCPe@CyBWgBDUBQ@kFh@g@?}ACe@AqBEU?}AF[B[DeCl@o@TyBt@aEtAqBl@o@FQ?gBMmAa@g@Q_Ag@Ge@QISFILCP@L[dBm@zC}@fEcAdFg@rECd@[fCO\\J\\OpBQfAG^w@~Cs@|A_CnDW^k@t@qDbFy@pAaApBcArCOl@k@~BmH~]cA~C[n@wArBiA~@mAp@oBp@qLvDyLxDQFyBt@eB~@MH_FxDUReJ`Hs@h@_DdCwEpDmCrBu@j@IFKHsRbOaBpAa@Z]V_BlAc@\\{I|GuAfA[TeBrAyBbBqB|AgAv@m@L]?}Da@_Ck@eBm@GCc@MUGQEcDo@w@KeA?}@Nu@^g@`@g@r@gApBsFzJWb@cAzB_@|@o@r@{@PIIWAQXCTJ^LFJt@N|CN|C@zBIdCODGJCTD^NPJ`BAhCFdDTzFDlAJhDEhE}B|Re@tD]rCEZi@lEu@hIo@jHIbAS`GCjACj@MxEEdBAj@E~@YpIe@vC_@lAi@|ArA|A|@tA\\h@nChEjA~Bv@fBr@`Bt@nBz@nCx@pC|BhKfAdHtB|TnD~`@B^Ht@\\~D\\pDJr@RpAT|AVdB\\jBR~@Lh@`@dBlAjEzA`EjAjCtBzDtBzCzBlCvAvAvErDj^|UTPnD`CfCpBfBjBe@nDEb@G|Ba@`XcA~_@AxE[zL}Enp@k@hH?rAXnTGjIg@`Fy@lHuAhOu@jKgA`KMfAInA@jBZpGHzB@jDMhEm@`MA`@GhAEj@Eh@YjAiExLAx@BR~BbDLLRV`BnBp@n@jChBtAhAd@z@v@rBVt@fAxCnEbMh@lBvDjPn@zEXhCr@bENl@h@vBfDhOxCrOZvA~@xENr@rBzJdCbP~@xFvEhUoH`EyHhC]Z@zI@`ANd^@`EBlE@~AFrMBxCBbG?^@z@BzGVzh@?f@DdIz@prBAt@CRIJc@`@eCdAwCdBkA~CyAxFqBdL}AfRq@|MM|Cw@zEI\\GTa@|Aw@nCMh@k@tBsF`SI^g@fBoMff@uDhNOj@YfAQj@iAnEOf@eAzDeBbGMb@_@zAQn@sD`N[fAELsFxOc@x@sApBuAhA_@Ly@L_ACeCUi@rA]z@Qd@kBbFwBzGaAnBYd@aDfFGHyB|DQb@j@j@bEzFPl@nDnDpEzDhDrDRRjG|Gh@l@lGhHp@t@zClD~BdCLNPNnPbQtBfClJbKxHxH~AjBvApBdA|Av@jAtAxBNV\\g@f@m@l@e@l@MX@f@VZn@HbAQpAKTaAvAYXOd@iJhK_BfBs@x@g@j@oO~PgOhQwNdQciA`wAwKbNWZuAfByZd`@eRdU_WnYgPdQs|@|}@kAjAe\\`]mLfMiZv]k^vd@yMrQwGjJcJlMiD`Fi@x@sCfEoJhN}BfDsBxCqC|DaPxTmNrQqWzZuJdLoGxHaCxCyKzN{EbHeKjPaLvSmXvk@uCtF_FtIsFfIcG`HcDtCqBvAqBlAwCrAcFfBeIxBsDdA{EhBsDjBsE~C}DlDwCbDsBlCeBnCc@p@_@p@oEbJ_ChFsAtCsBlEi@dAgCxEoGfK{BbDcC`DqFlGkOhOs@t@aEhE_I`JsMbQyUr]sJxM{J`MgI`JqPbPoLpJ_NpJcNbIyKvFcGjCcP~FaHtBaLrC{SjDwKlAkPbAyYl@sKLuCDuOZePj@}SrAqRhByDd@qIfAaNvBwWhF_MxCcNvDkIfCuQfG{MhFcN~FiPzHwPvI_g@nXqGjDyAx@_Bz@oCvA_@RwJ|EULgG|CiDvAg@TiEhBMFKD{Bz@sChAiPzFoNbEsNtD_UzE{T|Dow@hMoQlCeOfC{El@mKjBeLpB_UzE{MdDyLlDiStGgLhEkKjEuB|@{Ap@og@tUiLnFgY|MyFlCmCnAmB|@eAd@iIzDWLMF}At@qB~@qHlDgc@lSsCpA_@PkG~BkGjB}@TaARq@LiCf@sBZqBXcCTmFZgDHkKG}Hc@o@GcEk@{Do@yPwDqDu@yBe@c@GUEy@OeAKcAA{@Z[\\mAdB}@pAkBvCw@rA_B~Cy@|Aw@rAc@h@KLe@`@CHSLe@^cDxBs@f@q@b@oA|@oA|@yCrBeD|BeD|BMH_Ap@uA~@wA`AsA`Am@`@g@^[RI?{@b@UJu@Xi@PiBZYBiBFU@aCHmEHcBBqAFeAJO@K@{ANM@w@Bo@CoAGgA?W?q@AeCCwC}@gB}@KGe@Ia@Ry@x@u@p@q@r@eBdB_@^mAlAqArA_A`Am@p@ORF\\Pt@Jj@`@|BP`AUz@e@XsBdBiA|@k@b@e@Vc@t@c@l@e@h@]\\ITm@n@KPI\\Nl@Pn@DPH\\dBjHFn@D~@IrEKfBIxAAt@OpBGp@IfAOd@KJ]AEEg@s@][]DKTOx@S`BQrAEfAK~BOpAk@~BW\\SLMD_@AuAw@k@S{Bh@mBf@mAXwAZeAXQDmAXQF}A^QDSF',
                    routeCosts: {
                        countries: [
                            {
                                price: {
                                    price: 12.37,
                                    currency: 'EUR'
                                },
                                tollDistance: 69522,
                                countryCode: 'SK',
                                segments: [
                                    {
                                        name: '1204_Bratislava-Lamač - 1203_Stupava-juh',
                                        tollDistance: 5271,
                                        price: {
                                            price: 1,
                                            currency: 'EUR'
                                        }
                                    },
                                    {
                                        name: '1203_Stupava-juh - 1202_Lozorno',
                                        tollDistance: 9045,
                                        price: {
                                            price: 1.72,
                                            currency: 'EUR'
                                        }
                                    },
                                    {
                                        name: '1202_Lozorno - 1211_Malacky',
                                        tollDistance: 11474,
                                        price: {
                                            price: 2.18,
                                            currency: 'EUR'
                                        }
                                    },
                                    {
                                        name: '1211_Malacky - 1210_Kúty 1',
                                        tollDistance: 24091,
                                        price: {
                                            price: 4.58,
                                            currency: 'EUR'
                                        }
                                    }
                                ]
                            },
                            {
                                price: {
                                    price: 8.46,
                                    currency: 'EUR'
                                },
                                tollDistance: 40253,
                                countryCode: 'CZ',
                                segments: [
                                    {
                                        name: 'Podivín 41 - Hustopeče 25',
                                        tollDistance: 16495,
                                        price: {
                                            price: 3.47,
                                            currency: 'EUR'
                                        }
                                    },
                                    {
                                        name: 'Hustopeče 25 - Blučina 11',
                                        tollDistance: 13481,
                                        price: {
                                            price: 2.83,
                                            currency: 'EUR'
                                        }
                                    },
                                    {
                                        name: 'Blučina 11 - Chrlice 3',
                                        tollDistance: 8745,
                                        price: {
                                            price: 1.84,
                                            currency: 'EUR'
                                        }
                                    },
                                    {
                                        name: 'Chrlice 3 - Brno-jih ×D1 1',
                                        tollDistance: 1532,
                                        price: {
                                            price: 0.32,
                                            currency: 'EUR'
                                        }
                                    }
                                ]
                            }
                        ],
                        price: {
                            price: 20.83,
                            currency: 'EUR'
                        },
                        tollDistance: 109775
                    },
                    eventRules: [],
                    tasks: [
                        {
                            type: TransportPlaceTaskType.Loading,
                            action: undefined,
                            contactId: undefined,
                            loadingGoods: undefined,
                            unloadingGoods: undefined,
                            measurements: []
                        }
                    ]
                },
                {
                    name: 'Brno, Česko',
                    addressStructured: [
                        {
                            lang: 'cs',
                            address: '(CZ) 602 00, Brno, Veselá',
                            countryCode: 'CZ',
                            country: 'Česko',
                            town: 'Brno',
                            route: 'Veselá',
                            streetAddress: 'Veselá 172',
                            postalCode: '602 00'
                        },
                        {
                            lang: 'en',
                            address: '(CZ) 602 00, Brno, Veselá',
                            countryCode: 'CZ',
                            country: 'Czechia',
                            town: 'Brno',
                            route: 'Veselá',
                            streetAddress: 'Veselá 172',
                            postalCode: '602 00'
                        },
                        {
                            lang: 'sk',
                            address: '(CZ) 602 00, Brno, Veselá',
                            countryCode: 'CZ',
                            country: 'Česko',
                            town: 'Brno',
                            route: 'Veselá',
                            streetAddress: 'Veselá 172',
                            postalCode: '602 00'
                        }
                    ],
                    center: {
                        type: 'Point',
                        coordinates: [16.60684, 49.19506]
                    },
                    polygon: {
                        type: 'Polygon',
                        coordinates: [
                            [
                                [16.6068371, 49.19685683056824],
                                [16.609218066301306, 49.19595851528412],
                                [16.609218066301306, 49.19416188471588],
                                [16.6068371, 49.193263569431764],
                                [16.604456133698694, 49.19416188471588],
                                [16.604456133698694, 49.19595851528412],
                                [16.6068371, 49.19685683056824]
                            ]
                        ]
                    },
                    crossingPoints: [],
                    distance: 157487,
                    duration: 8740,
                    durationBuffer: undefined,
                    route: '',
                    routeCosts: undefined,
                    eventRules: [],
                    tasks: []
                }
            ],
            routeOptionsSygic: {
                avoidOptionsSygic: [],
                possibleAvoidsSygic: {
                    svk: ['tolls', 'highways', 'country'],
                    cze: ['tolls', 'highways', 'country']
                }
            },
            puesc: false
        },
        clientId: 8559,
        createdAt: undefined,
        createdBy: undefined,
        deactivatedAt: undefined,
        deactivatedBy: undefined,
        previousVersionId: '6405a9a4e2b0012ffab5f694',
        id: '642e9c1b21d749e3b8caaafd'
    }
];
